/**
* 头部菜单
*/
<template>
    <div>
        <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
            <el-button class="buttonimg">
                <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
            </el-button>
            <!-- <div @click="hadleApp">进入应用管理后台</div> -->
            <el-submenu index="2" class="submenu">
                <template slot="title">超级管理员</template>
                <el-menu-item @click="edit()" index="2-4">修改密码</el-menu-item>
                <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
            </el-submenu>
        </el-menu>
        <el-dialog title="修改密码" :visible="dialogFormVisible" width="30%" :before-close="handleClose" :closeOnClickModal="false">
            <el-form label-width="80px" ref="model" :model="model" :rules="rules">
                <el-form-item label="用户密码" prop="UserPwd">
                    <el-input size="small" v-model="model.UserPwd" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="comUserPwd">
                    <el-input size="small" v-model="model.comUserPwd" auto-complete="off" placeholder="确认密码" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='handleClose'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
            </div>
        </el-dialog>
    </div>


</template>

<script>
    import {
        UpdateAdmin
    } from '../../api/user'
    import storage from '../../common/storage'
    export default {
        name: 'navcon',
        data() {
            let validUserPwd = (rule, value, callback) => {
                let reg = /[\u4E00-\u9FA5]/i;
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if (reg.test(value)) {
                    callback(new Error('密码不能为中文'))
                } else if (value.length < 6) {
                    callback(new Error('密码长度不能小于6'))
                } else {
                    callback();
                }
            };
            let validComUserPwd = (rule, value, callback) => {
                if (value != this.model.UserPwd) {
                    callback(new Error('两次输入的密码不一致'))
                }
            };
            return {
                collapsed: false,
                imgshow: require('../../../public/static/image/show.png'),
                imgsq: require('../../../public/static/image/sq.png'),
                user: {},
                model: {
                    UserId: null,
                    UserName: '',
                    UserPwd: '',
                    comUserPwd: ''
                },
                rules: {
                    UserPwd: [{ required: true, trigger: 'blur', validator: validUserPwd }],
                    comUserPwd: [{ required: true, trigger: 'blur', validator: validComUserPwd, }],
                },
                dialogFormVisible: false,
                comUserPwd: ""
            }
        },
        // 创建完毕状态(里面是操作)
        created() {
            this.user = JSON.parse(localStorage.getItem('userdata'))
        },
        methods: {
            // 退出登录
            exit() {
                this.$confirm('退出登录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        setTimeout(() => {
                            storage.removeSession('token')
                            storage.removeSession('ConversationID')
                            storage.removeSession('userinfo')
                            this.$router.push({ path: '/login' })
                            this.$message({
                                type: 'success',
                                message: '已退出登录!'
                            })
                        }, 1000)
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        })
                    })
            },
            // 切换显示
            toggle() {
                this.collapsed = !this.collapsed;
                this.$emit('collapseChange', this.collapsed)
                // this.$root.Bus.$emit('toggle', this.collapsed)
            },
            UpdateAdmin() {
                UpdateAdmin(this.model).then(data => {
                    if (!data.iserror) {
                        this.loading = false;
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            handleSave() {
                if (this.model.UserPwd != this.model.comUserPwd) {
                    this.$message({
                        message: '两次输入密码不一致',
                        type: 'warning'
                    });
                    return false;
                }
                delete this.model.comUserPwd;
                this.UpdateAdmin();
            },
            handleClose() {
                this.dialogFormVisible = false;
            },
            edit() {
                this.dialogFormVisible = true;
                let userinfo = JSON.parse(storage.getSession('userinfo'))
                this.model.UserId = userinfo.Uid;
                this.model.UserName = userinfo.Uname;
            }
        }
    }
</script>
<style scoped>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        border: none;
    }

    .submenu {
        float: right;
    }

    .buttonimg {
        height: 60px;
        background-color: transparent;
        border: none;
    }

    .showimg {
        width: 26px;
        height: 26px;
        position: absolute;
        top: 17px;
        left: 17px;
    }

    .showimg:active {
        border: none;
    }
</style>